/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({
  questionnaire,
}) {
  return questionnaire.map(question => {
    /*     if ([136, 137, 138, 167].includes(question.idQuestion) && question?.answerOptions?.length) {
          question.answerOptions = question.answerOptions.map(answerOption => {
            return {
              ...answerOption,
              dsAnswerOption: "",
              behaviorObject: {
                ...answerOption.behaviorObject,
                horizontalAlign: "center",
              }
            }
          });
        } */

    if ([136, 137, 138, 167, 2046].includes(question.idQuestion) && !question.answer) {
      question.answer = [];
    }
    return question;
  })
};

const handleSelect = async ({ value, key, setQuestionnaire, globalQuestionnaire, formikRef }) => {
  let valuesAux = formikRef.current?.values[key];
  
  const checked = !!formikRef.current?.values[key].find(({ idAnswerOption }) => idAnswerOption === value.idAnswerOption);
  
  if (checked) {
    valuesAux = formikRef.current?.values[key].filter(({ idAnswerOption }) => idAnswerOption !== value.idAnswerOption);
  } else {
    valuesAux = [
      ...formikRef.current?.values[key],
      {
        idAnswerOption: value.idAnswerOption,
        dsAnswerOption: value.dsAnswerOption
      }
    ];
  };

  await formikRef.current.setFieldValue(key, valuesAux);
  globalQuestionnaire = globalQuestionnaire.map(qst => {
    if (qst.idQuestion === value.idQuestion) {
      qst.answer = valuesAux;
    }
    return qst
  });
  setQuestionnaire(globalQuestionnaire)
};

const handleChecked = (value, formikRef) => {
  if (!formikRef?.current.values[value.key]) {
    return;
  };
  return !!(formikRef.current?.values[value.key].find(({ idAnswerOption }) => idAnswerOption === value.idAnswerOption))
};

const getQuestionAnswer = (question, setFieldValue) => {
  if (!question) return "";

  if (question.answer == null) question.answer = [];
  if (question.idDomainQuestion === 44 && Array.isArray(question.answer)) {
    question.answer = question.answer.filter((v) => question.answerOptions?.find((o) => o.idAnswerOption === v.idAnswerOption));
    setFieldValue && setFieldValue(question.key, question?.answer || question.behaviorObject.defaultValue || "");
    
    return;
  }
};

const events = {
   handleInitialAdjustments,
   getQuestionAnswer,
   handleChecked,
   handleSelect,
};

export { events };